import utils from '@/utils/utils'

export default {
  yflife: 'https://corp.yflife.com',
  app_download: (function setDownloadUrl () {
    const apple = 'https://www.mycx.hk/r/yflinkapple'
    const android = 'https://www.mycx.hk/r/yflinkgoogle'
    return utils.isApple() ? apple : android
  })()
}
